import { render, staticRenderFns } from "./PDragAndDrop.vue?vue&type=template&id=481e83da&scoped=true&"
import script from "./PDragAndDrop.vue?vue&type=script&lang=ts&"
export * from "./PDragAndDrop.vue?vue&type=script&lang=ts&"
import style0 from "./PDragAndDrop.vue?vue&type=style&index=0&id=481e83da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e83da",
  null
  
)

export default component.exports